export enum PaginationParams {
  limit = 'limit',
  page = 'page',
  skip = 'skip',
}
